import { render } from "./VerifyContactPage.vue?vue&type=template&id=dee99728&scoped=true"
import script from "./VerifyContactPage.vue?vue&type=script&lang=js"
export * from "./VerifyContactPage.vue?vue&type=script&lang=js"

import "./VerifyContactPage.vue?vue&type=style&index=0&id=dee99728&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dee99728"]])

export default __exports__